import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import companiesService, { Company } from "../../features/companies/companiesService";
import { isAdmin } from "../../utils/permissions";
import { setSelectedClient } from "../../features/settings/settingsSlice";

const WhatsappChatbotsPage: React.FC = () => {
  const dummy = [
    { id: 1, name: "Support Bot", phone: "+1 (555) 111-2233", status: "active" },
    { id: 2, name: "Sales Assistant", phone: "+1 (555) 333-4455", status: "paused" },
    { id: 3, name: "Onboarding Bot", phone: "+1 (555) 666-7788", status: "draft" },
  ];

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((s: RootState) => s.auth);
  const [singleCompanies, setSingleCompanies] = useState<Company[]>([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | "">("");
  useEffect(() => {
    const load = async () => {
      if (!isAdmin(user)) return;
      const { companies } = await companiesService.getCompanies({ company_type: 'single', limit: 200 });
      setSingleCompanies(companies || []);
    };
    load();
  }, [user]);

  return (
    <div className="whatsapp-chatbots-page">
      <div className="page-header">
        <div className="header-left">
          <div className="header-icon" style={{background: "linear-gradient(135deg, #22c55e, #16a34a)"}}>
            <i className="bi bi-whatsapp" />
          </div>
          <div className="header-text">
            <h1>WhatsApp Chatbots</h1>
            <p>Automate support and sales on WhatsApp with smart assistants</p>
          </div>
        </div>
        <div className="header-right">
          {isAdmin(user) && (
            <div>
              <select
                className="form-select"
                value={selectedCompanyId}
                onChange={(e) => {
                  const val = e.target.value ? Number(e.target.value) : "";
                  setSelectedCompanyId(val);
                  (dispatch as any)(setSelectedClient(typeof val === 'number' ? val : undefined));
                }}
                style={{ minWidth: 220 }}
              >
                <option value="">Select company</option>
                {singleCompanies.map((c) => (
                  <option key={c.id} value={c.id}>{c.company_name}</option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>

      <div className="bots-grid">
        {dummy.map((b) => (
          <div key={b.id} className="bot-card">
            <div className="bot-header">
              <div className="bot-icon"><i className="bi bi-robot" /></div>
              <div className="bot-meta">
                <div className="bot-title">{b.name}</div>
                <div className="bot-sub">{b.phone}</div>
              </div>
              <div className={`status ${b.status}`}>{b.status}</div>
            </div>
            <div className="bot-actions">
              <button className="btn btn-sm btn-outline-primary">View Metrics</button>
              <button className="btn btn-sm btn-outline-secondary">Configure</button>
            </div>
          </div>
        ))}
      </div>

      <style>{`
.whatsapp-chatbots-page { padding: 24px; }
.page-header { display:flex; justify-content:space-between; gap:16px; padding:20px 24px; background:var(--bg-primary); border:1px solid var(--border-color); border-radius:16px; margin-bottom: 14px; }
.header-left { display:flex; align-items:center; gap:14px; }
.header-icon { width:46px; height:46px; border-radius:12px; color:#fff; display:flex; align-items:center; justify-content:center; font-size:20px; }
.header-text h1 { margin:0; font-size:22px; font-weight:700; color:var(--text-primary); }
.header-text p { margin:2px 0 0; color:var(--text-muted); font-size:14px; font-weight:500; }
.bots-grid { display:grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap:14px; margin-top: 12px; }
.bot-card { background: var(--bg-primary); border:1px solid rgba(148,163,184,.6); border-radius:16px; padding:16px; transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease; }
.bot-card:hover { transform: translateY(-3px); box-shadow: 0 14px 30px rgba(15,23,42,.15); border-color: rgba(59,130,246,.5); }
.bot-header { display:flex; align-items:center; gap:12px; }
.bot-icon { width:36px; height:36px; border-radius:10px; background: linear-gradient(135deg, #22c55e, #16a34a); color:#fff; display:flex; align-items:center; justify-content:center; }
.bot-meta { flex:1; min-width: 0; }
.bot-title { font-weight:800; color:var(--text-primary); }
.bot-sub { color:var(--text-secondary); font-size: 13px; margin-top: 2px; }
.status { display:inline-block; margin-top:10px; padding:4px 10px; border-radius:999px; border:1px solid var(--border-color); font-size:12px; text-transform: capitalize; }
.status.active { color:#10b981; border-color: rgba(16,185,129,.4); background: rgba(16,185,129,.08); }
.status.paused { color:#f59e0b; border-color: rgba(245,158,11,.4); background: rgba(245,158,11,.08); }
.status.draft { color:#64748b; border-color: rgba(100,116,139,.4); background: rgba(100,116,139,.08); }
.bot-actions { display:flex; gap:8px; margin-top: 12px; }
      `}</style>
    </div>
  );
};

export default WhatsappChatbotsPage;


